import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { 
    listDocuments, 
    createDocumentType, 
    getDocumentType, 
    updateDocumentType, 
    deleteDocumentType, 
    listDocumentTypes,
    updateDocument
} from "../api/documentRepository";

export const useListDocuments = () => {
    return useQuery({
        queryKey: ['documents'],
        queryFn: listDocuments,
    });
};

// Document Types Hooks
export const useListDocumentTypes = () => {
    return useQuery({
        queryKey: ['documentTypes'],
        queryFn: listDocumentTypes,
    });
};

export const useGetDocumentType = (id) => {
    return useQuery({
        queryKey: ['documentType', id],
        queryFn: () => getDocumentType(id),
        enabled: !!id,
    });
};

export const useCreateDocumentType = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: createDocumentType,
        onSuccess: () => {
            queryClient.invalidateQueries(['documentTypes']);
        },
    });
};

export const useUpdateDocumentType = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: updateDocumentType,
        onSuccess: () => {
            queryClient.invalidateQueries(['documentTypes']);
        },
    });
};

export const useDeleteDocumentType = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: deleteDocumentType,
        onSuccess: () => {
            queryClient.invalidateQueries(['documentTypes']);
        },
    });
};

export const useUpdateDocument = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: updateDocument,
        onSuccess: () => {
            queryClient.invalidateQueries(['documents']);
        },
    });
};
